

define(['angular', 'squid/index', 'text!./template.html', 'onetouch-interstitial/kmliUpsell', 'components/xo-tracking/dist/index', 'components/ul-inline/dist/inject', 'components/xo-device-info/dist/index'], function (angular, squid, template) {
    return angular.module('xo-unified-login.directive', ['squid', 'xo-unified-login.kmliUpsell', 'tracking', 'xolocale', 'xo-device-info', 'xo-fn']).directive('xoUnifiedLogin', function () {
        return {
            template: template,
            scope: {
                token: '=',
                redirectUri: '=',
                parentCallback: '=',
                doneFn: '=',
                errorFn: '=',
                autoLogin: '=',
                promptlogin: '=',
                logoutCallback: '=',
                kmli: '=',
                preAuth: '=',
                postAuth: '=',
                flowcontext: '='
            },
            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $LocaleModel, $config, $state, $stateParams, $timeout, $FallbackError, $KmliUpsell, $logger, $locale, $fpti, $AuthModel, $util, $pxp, $CalDataModel, $meta, $DeviceInfo, $pxpMatch, $feature, $q, $CheckoutCartModel, $fn) {
                var PAYPAL = window.PAYPAL || {};
                var loginAttemptedMethod = '';
                var userSelectedLanguage = '';
                var failureReasons = {
                    timeout: 'TIMEDOUT',
                    error: 'INTERNALERROR',
                    blacklistedDevice: 'PLATFORM_NOT_SUPPORTED',
                    fallback: 'FALLBACK'
                };
                var enteringTime = Date.now();
                $logger.debug('ENTERING_LOADING_UL_IFRAME', { enteringTime: enteringTime });
                $scope.locale = $LocaleModel.instance();
                $scope.forcedLogin = !$scope.autoLogin; // change to true during forcedLogin scenario

                if ($stateParams.source === 'NOT_YOU' || $stateParams.source === 'FRESH_START') {
                    $scope.forcedLogin = false;
                }

                var ulTimeoutLimit = 35000;
                var ulTimeoutPromise = null;

                var loadCnt = 0;

                function setLoading(tag, isRT) {
                    $rootScope.$emit('loading');
                    if (isRT && !$scope.auth.loggedIn()) {

                        if ($feature('rmSpinnerText')) {
                            $rootScope.$emit('loadingMessage', {
                                heading: $locale.content.get('base.loggingIn'),
                                subHeading: $locale.content.get('login.rmSubHeading')
                            });
                        } else {
                            $rootScope.$emit('loadingMessage', $locale.content.get('base.loggingIn'));
                        }
                    }
                    loadCnt++;
                    $logger.debug('setLoading by ' + tag + ' cnt ' + loadCnt);
                }

                function setLoaded(tag) {
                    if (loadCnt > 0) {
                        $rootScope.$emit('loaded');
                        loadCnt--;
                    } else {
                        $logger.error('loadCnt_zero');
                    }
                    $logger.debug('setLoaded by ' + tag + ' cnt ' + loadCnt);
                }

                function fallback(product, reason, params) {
                    throw new $FallbackError({
                        product: product || 'ux',
                        reason: reason,
                        params: params
                    });
                }

                function appLoginHandler(status) {
                    $logger.debug('ULLOGIN_' + status);
                    $logger.info('checkout_fpti', { 'from': 'LOGIN', 'to': 'prepare_login' });
                    $scope.parentCallback('toggleUnifiedLogin', false);
                    setLoaded('appLogin');
                }

                var startTimerTS;
                function startTimer(tag) {
                    startTimerTS = Date.now();

                    $logger.debug('startTimer by ' + tag, {
                        startTime: startTimerTS
                    });
                    $logger.info('checkout_fpti', {
                        'from': 'UL_Timer',
                        'to': 'prepare_' + tag
                    });

                    ulTimeoutPromise = $timeout(function () {
                        $logger.error('load_ul_timeout');
                        var stop_time = Date.now();
                        var time_taken = stop_time - startTimerTS;
                        $logger.info('checkout_fpti', {
                            'from': 'UL_Timer',
                            'to': 'process_timeout',
                            'int_error_code': 'ULLOGIN_TIMEOUT',
                            'int_error_description': 'ULLOGIN_TIMEOUT',
                            'error_source': 'unifiedloginnodeweb',
                            'error_type': 'soft_decline',
                            'page_load_time': time_taken
                        });
                        fallback('ux', 'ul_load_timeout');
                    }, ulTimeoutLimit);
                }

                function stopTimer(tag, keepLoading) {
                    var stopTimerTS = Date.now();
                    var timeTaken = stopTimerTS - startTimerTS;

                    $logger.debug('stopTimer by ' + tag, {
                        stopTimer: stopTimerTS,
                        page_load_time: timeTaken
                    });

                    $logger.info('checkout_fpti', {
                        'from': 'UL_Timer',
                        'to': 'process_' + tag,
                        'page_load_time': timeTaken
                    });

                    if (!keepLoading) {
                        setLoaded('stopTimer');
                    }

                    if (ulTimeoutPromise) {
                        $timeout.cancel(ulTimeoutPromise);
                    }
                }

                function logFptiData(fptiData, eventName) {
                    var errorDescription;
                    switch (eventName) {
                        case '2fa':
                            errorDescription = '2fa_required';
                            break;
                        case 'safeRequired':
                            errorDescription = 'SAFE_required';
                            break;
                        case 'stepupRequired':
                            errorDescription = 'Login_ATO_required';
                            break;
                        default:
                        // nothing to do here
                    }
                    $logger.info('checkout_fpti', {
                        'from': fptiData.fptiState,
                        'to': fptiData.fptiTransition,
                        'int_error_code': eventName,
                        'int_error_description': errorDescription,
                        'error_type': 'soft_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }

                function buildRedirectURL(contingencyUrl, eventName) {
                    var authChallengeUrl = contingencyUrl;
                    var paramIndex = authChallengeUrl.indexOf('?');
                    var urlParams = $util.params(authChallengeUrl.substring(paramIndex + 1));

                    urlParams.returnUri = $config.ulMeta.authChallengeReturnUri;
                    if (userSelectedLanguage) {
                        urlParams['locale.x'] = $locale.getLocaleCode();
                        urlParams['state'] += '&locale.test=' + $locale.getLocaleCode();
                    }
                    switch (eventName) {
                        case '2fa':
                            urlParams['state'] += '&acRedirect=2fa&ulMethod=' + loginAttemptedMethod;
                            break;
                        case 'safeRequired':
                            urlParams['state'] += '&acRedirect=safe';
                            break;
                        case 'stepupRequired':
                            urlParams['state'] += '&acRedirect=loginato';
                            break;
                        default:
                        // nothing to do here
                    }
                    var redirectUrl = $util.buildURL(authChallengeUrl.substring(0, paramIndex), urlParams);
                    return redirectUrl;
                }

                if (!$config.ulMeta) {
                    $logger.error('config_no_ulMeta');
                }

                var ulMeta = $config.ulMeta || {};

                $populate($scope, {
                    auth: $AuthModel.instance(),
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token)
                }).then(function () {
                    var country = $scope.checkoutAppData.merchant.merchant_country;
                    var pxpKmli = $pxp(ulMeta.pxpExpId, { 'ctx.COUNTRY': country }, 'xo_hermesnode_kmli_(web|mobile)_treatment');
                    var pxpTimeoutTrt = $pxp(ulMeta.pxpExpId, { 'ctx.COUNTRY': country }, 'xo_hermes_ul_timeout_treatment.*');

                    var configPxpResults = $pxpMatch(ulMeta.hermesnodePxpConfig, { 'ctx.COUNTRY': country }, {
                        pxpSAFE: 'xo_hermesnode_ul_safe_treatment'
                    });

                    return $q.all([pxpKmli, configPxpResults, pxpTimeoutTrt]).then(function (result) {
                        var kmliTreatments = result[0];
                        var config_pxp_treatments = result[1];
                        if (config_pxp_treatments) {
                            $scope.safeEligibility = config_pxp_treatments['pxpSAFE'];
                        }
                        $scope.kmliEligibility = Boolean(kmliTreatments && kmliTreatments.treatment_name);
                        var timeoutTrtFact = result[2] && angular.isArray(result[2].factors);
                        var pxpTimeoutVal = timeoutTrtFact && result[2].factors[0] && result[2].factors[0].value;
                        if (pxpTimeoutVal) {
                            ulTimeoutLimit = pxpTimeoutVal;
                            $logger.info('pxp_timeout_treatment', {
                                'ulTimeoutLimit': ulTimeoutLimit
                            });
                        }
                    });
                }).then(function () {
                    var isRememberedUser = $scope.auth.refreshToken();
                    setLoading('loadUL', isRememberedUser);

                    // STEP1: Check PXP response
                    var pxpGroup = $scope.kmliEligibility ? 'pxpTreatment' : 'pxpControl';

                    var reasons = [];
                    reasons.push(pxpGroup);

                    // STEP2: Check for conditions that deviates from the PXP eligibility
                    function routingReason() {
                        if ($scope.kmli === true) {
                            return 'kmliMandated';
                        } else if (isRememberedUser) {
                            return 'rememberedUser';
                        } else if ($util.param('ul') === '2') {
                            return 'ulParam';
                        } else if ($meta.corp && ulMeta.allowKMLIForInternalIP) {
                            var merchantCountry = $scope.checkoutAppData.merchant.merchant_country;
                            if ($feature('enableOneTouchInternalIP', false, merchantCountry)) {
                                return 'internalIP';
                            }
                        } else if (ulMeta.enableOneTouchByDefault) {
                            return 'oneTouchByDefault';
                        }
                    }

                    // Reasons that deviates from control to treatment
                    var rr = pxpGroup === 'pxpControl' && routingReason();
                    if (rr) {
                        $scope.kmliEligibility = true;
                        reasons.push(rr);
                    }

                    // STEP3: Check for compatibility/environment issues which impacts UL/KMLI overall
                    // This should override previous decisions
                    if ($DeviceInfo.isApp() && !$DeviceInfo.isSafariViewController()) {
                        $scope.kmliEligibility = false;
                        reasons.push('Webview');
                    } else if (!$util.cookiesEnabled()) {
                        $scope.kmliEligibility = false;
                        reasons.push('cookiesDisabled');
                    }

                    if ($scope.forcedLogin === true) {
                        $scope.kmliEligibility = false;
                        reasons.push('forcedLogin');
                    }
                    if ($scope.logoutCallback) {
                        $scope.kmliEligibility = true;
                        reasons.push('riskyLoginContingency');
                    }

                    var routing_reason = reasons[reasons.length - 1];

                    // STEP4: Instrument deterministically whether KMLI is shown to the user or not
                    var rememberMe = $scope.kmliEligibility;
                    $logger.debug($scope.kmliEligibility ? 'KMLI_ELIGIBLE_USER' : 'KMLI_INELIGIBLE_USER', { userGroup: reasons, routing_reason: routing_reason });
                    $logger.info('checkout_fpti', {
                        'from': 'KMLI_ELG_CHK',
                        'to': 'process_kmli_elg_chk',
                        'routing_reason': routing_reason
                    });

                    var app_int_type = $DeviceInfo.getAppIntegrationType();

                    if (isRememberedUser && !$scope.forcedLogin) {
                        $logger.info('checkout_fpti', {
                            'from': 'LOGIN_UL_RM',
                            'to': 'prepare_login_ul_RM',
                            'app_int_type': app_int_type
                        });
                    }

                    function getPostLoginFpti(data) {
                        var result;

                        if (data.event === 'tokenExchanged') {
                            result = { fptiState: 'LOGIN_UL_RM', fptiTransition: 'process_RT_AT_exch' };
                        } else {
                            var fptiTransitionName = data.keepMeLoggedIn === true ? 'process_login_UL_RM' : 'process_login_UL';
                            var ULState = rememberMe === true ? 'LOGIN_UL_RM' : 'LOGIN_UL';
                            result = { fptiState: ULState, fptiTransition: fptiTransitionName };
                        }

                        return result;
                    }

                    var cancelLocaleChange;

                    function loginComplete(data) {
                        $scope.auth.stepupAuthRequired = false;

                        stopTimer('loginComplete');

                        if (cancelLocaleChange) {
                            cancelLocaleChange();
                        }

                        $scope.auth.isKmliSet = data.keepMeLoggedIn || data.event === 'tokenExchanged';
                        $scope.auth.rtExchanged = data.event === 'tokenExchanged';

                        var fptiData = getPostLoginFpti(data);

                        $logger.info('checkout_fpti', {
                            'from': fptiData.fptiState,
                            'to': fptiData.fptiTransition
                        });

                        var upsellEligibilityData = {
                            ulData: data
                        };

                        // Doesn't exist in risky login case
                        if ($scope.preAuth) {

                            // Fires off eligibility + econsent + xosession in batch mode
                            $scope.preAuth();
                        }

                        if (data.event === 'tokenExchanged') {
                            if ($feature('rmSpinnerText')) {
                                $rootScope.$emit('loadingMessage', {
                                    heading: $locale.content.get('base.planning'),
                                    subHeading: $locale.content.get('login.rmSubHeading')
                                });
                            } else {
                                $rootScope.$emit('loadingMessage', $locale.content.get('base.planning'));
                            }
                        }

                        $scope.auth.reload({
                            resultModel: $scope.auth,
                            headers: {
                                'x-paypal-internal-euat': data.accessToken
                            },
                            batch: {
                                name: 'setbuyer',
                                id: 'securityCtx',
                                dependencies: []
                            },

                            success: function success() {
                                $scope.auth.is_auth_api_call = data.event === 'tokenExchanged';

                                angular.extend(upsellEligibilityData, {
                                    buyerCountry: $scope.auth.country,
                                    idToken: $scope.auth.idTokenPresent,
                                    kmliEligible: $scope.kmliEligibility,
                                    upsellOptInDisplayed: $scope.auth.upsellOptInDisplayed,
                                    showReactivationInterstitial: $scope.showReactivationInterstitial
                                });

                                $KmliUpsell.init(upsellEligibilityData);

                                $scope.postAuth($scope.auth);
                            },
                            contingencies: {
                                DEFAULT: function handleContingency(name, contingency) {
                                    $scope.auth.password = '';
                                    $scope.errorFn(name, contingency);
                                }
                            }
                        });
                    }

                    var ulEventHandlers = {
                        'loginRendered': function loginRendered() {
                            var loadingCompletedTime = Date.now();
                            $logger.debug('ULLOGIN_FRAME_LOADED_SUCCESSFULLY', {
                                page_load_time: loadingCompletedTime - enteringTime
                            });
                        },
                        'loginFullyLoaded': function loginFullyLoaded(data) {
                            stopTimer(data.event);

                            if ($scope.notYou) {
                                $rootScope.$emit('loaded');
                                delete $scope.notYou;
                                $logger.info('checkout_fpti', {
                                    'from': 'LOGIN_UL_RM',
                                    'to': 'prepare_login_ul'
                                });
                                $fn.sendTypingSpeedPayload('HermesUL');
                                return $scope.logoutCallback();
                            }

                            if (!$state.current.trackingData) {
                                $state.current.trackingData = { fptiState: 'ulLoginDefault' };
                            }
                            $state.current.trackingData.pageQualifier = 'ulLogin';
                            var loadingCompletedTime = Date.now();
                            var timeTaken = loadingCompletedTime - enteringTime;
                            $logger.debug('ULLOGIN_LOADED_SUCCESSFULLY', {
                                page_load_time: timeTaken
                            });

                            var ULState = rememberMe === true && !$scope.logoutCallback ? 'LOGIN_UL_RM' : 'LOGIN_UL';

                            $logger.info('checkout_fpti', {
                                'from': ULState,
                                'to': 'prepare_iframe',
                                'page_load_time': timeTaken
                            });

                            var payload = {
                                'from': ULState,
                                'to': 'prepare_login_ul',
                                'app_int_type': app_int_type
                            };

                            if ($stateParams.targetPage) {
                                angular.extend(payload, { 'int_error_code': $stateParams.targetPage });
                            }

                            $logger.info('checkout_fpti', payload);

                            $fn.sendTypingSpeedPayload('HermesUL');
                        },
                        'loginEmailPasswordAttempted': function loginEmailPasswordAttempted() {
                            loginAttemptedMethod = 'email';
                        },
                        'loginPhonePinAttempted': function loginPhonePinAttempted() {
                            loginAttemptedMethod = 'phone';
                        },
                        'loginAttempted': function loginAttempted(data) {
                            setLoading(data.event);
                            $rootScope.$emit('loadingMessage', $locale.content.get('base.loggingIn'));
                            if (rememberMe === true) {
                                var kmliStatus = data.keepMeLoggedIn === true ? 'KMLI_CHECKED' : 'KMLI_UNCHECKED';
                                $logger.debug(kmliStatus);
                            }
                            startTimer(data.event);
                        },
                        'loginSuccess': loginComplete,
                        'tokenExchanged': loginComplete,
                        'notYouLinkClicked': function notYouLinkClicked(data) {
                            $rootScope.$emit('loading');
                            $scope.notYou = true;
                            $logger.info('checkout_fpti', {
                                from: 'LOGIN_UL',
                                to: 'login_with_diff_user'
                            });
                            startTimer(data.event);
                        },
                        '2fa': function fa(data) {
                            stopTimer(data.event);
                            var fptidata = getPostLoginFpti(data);
                            logFptiData(fptidata, data.event);
                            if (data.contingencyUrl) {
                                $logger.debug('ULLOGIN_TWO_FA_AUTH_REDIRECT');
                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
                                $util.redirect(authChallengeRedirectUrl);
                            } else {
                                $logger.debug('ULLOGIN_TWO_FA_GENERIC_ERROR');
                                $state.go('checkout.genericError', { code: 'DEFAULT' });
                            }
                        },
                        'safeRequired': function safeRequired(data) {
                            stopTimer(data.event);
                            var fptidata = getPostLoginFpti(data);
                            logFptiData(fptidata, data.event);
                            if ($scope.safeEligibility && data.contingencyUrl) {
                                if (data.authorizationType && data.authorizationType === 'token') {
                                    // for remembered user redirect to login instead of SAFE APP
                                    $logger.debug('LOGIN_REDIRECTION_SAFE_RM_USER');
                                    $state.go('checkout.login', { targetPage: 'LOGIN_CONTINGENCY' });
                                }
                                $logger.debug('ULSAFE_REDIRECTION');
                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
                                $util.redirect(authChallengeRedirectUrl);
                            } else {
                                $logger.debug('ULSAFE_GENERIC_ERROR');
                                $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                            }
                        },
                        'serverError': function serverError(data) {
                            stopTimer(data.event);
                            var error_code = 'INVALID_USER';
                            var error = {
                                type: 'pageError',
                                code: 500
                            };
                            // internalServerError, code: 500, take user to hermes login, no need for error message
                            switch (data.reason) {
                                case 'serverValidationError':
                                    if (data.authorizationType === 'token') {
                                        error_code = 'ONETOUCH_GENERIC_ERROR';
                                        error.msg = $locale.content.get('login.reactivateOneTouch');
                                    } else if (loginAttemptedMethod === 'phone') {
                                        error_code = 'INVALID_PHONE_PIN';
                                        error.msg = $locale.content.get('login.invalidPin');
                                    } else {
                                        error.msg = $locale.content.get('login.invalidEmailPasswordPageError');
                                    }
                                    break;
                                case 'invalidUser':
                                    if (data.authorizationType === 'token') {
                                        error_code = 'ONETOUCH_GENERIC_ERROR';
                                        error.msg = $locale.content.get('login.reactivateOneTouch');
                                    }
                                    break;
                                case 'internalServerError':
                                    if (data.authorizationType === 'token') {
                                        error_code = 'ONETOUCH_GENERIC_ERROR';
                                        error.msg = $locale.content.get('login.reactivateOneTouch');
                                    } else {
                                        error.msg = $locale.content.get('login.invalidEmailPasswordPageError');
                                    }
                                    $fpti.setupDataString($state.current, error);
                                    return appLoginHandler(failureReasons.error);
                                case 'accountTemporaryLocked':
                                case 'accountPermanentlyLocked':
                                    error.code = data.code;
                                    error.msg = $locale.content.get('login.accountLockedPageError');
                                    error_code = 'ACCOUNT_LOCKED';
                                    break;
                                case 'riskDecline':
                                    error.code = data.code;
                                    if (data.authorizationType === 'token') {
                                        error_code = 'ONETOUCH_GENERIC_ERROR';
                                        error.msg = $locale.content.get('login.reactivateOneTouch');
                                    } else {
                                        error.msg = $locale.content.get('login.riskDeclinePageError');
                                        error_code = 'RISK_DECLINE';
                                    }
                                    break;
                                default:
                                // Do nothing
                            }
                            var fptidata = getPostLoginFpti(data);
                            $logger.info('checkout_fpti', {
                                'from': fptidata.fptiState,
                                'to': fptidata.fptiTransition,
                                'int_error_code': data.code,
                                'int_error_description': data.reason,
                                'error_type': 'soft_decline',
                                'error_source': 'unifiedloginnodeweb'
                            });
                            $fpti.setupDataString($state.current, error);
                            $scope.parentCallback('showErrorMessages', error_code);
                        },
                        'client_validation_error': function client_validation_error(data) {
                            var error = {
                                type: 'pageError',
                                msg: $locale.content.get('login.invalidEmailPasswordPageError')
                            };
                            var fptidata = getPostLoginFpti(data);
                            $logger.info('checkout_fpti', {
                                'from': fptidata.fptiState,
                                'to': fptidata.fptiTransition,
                                'int_error_code': data.event,
                                'int_error_description': 'invalid_credentials',
                                'error_type': 'soft_decline',
                                'error_source': 'unifiedloginnodeweb'
                            });
                            $fpti.setupDataString($state.current, error);
                        },
                        'stepupRequired': function stepupRequired(data) {
                            stopTimer(data.event);
                            var fptidata = getPostLoginFpti(data);
                            logFptiData(fptidata, data.event);

                            if (data.authorizationType && data.authorizationType === 'token') {
                                // for remembered user redirect to login instead of AuthChallenge APP
                                $logger.debug('LOGIN_ATO_RM_USER');

                                //doing nothing, ul will render the login page, we need to show warning on top though
                                var error_code = 'ONETOUCH_GENERIC_ERROR';
                                var error = {
                                    type: 'pageError',
                                    msg: $locale.content.get('login.reactivateOneTouch')
                                };
                            } else if (data.contingencyUrl) {
                                $logger.debug('LOGIN_ATO_USER');
                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
                                $util.redirect(authChallengeRedirectUrl);
                            } else {
                                $logger.debug('LOGIN_ATO_GENERIC_ERROR');
                                $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                            }
                            //to show error message on login page
                            $scope.parentCallback('showErrorMessages', error_code);
                        },

                        'captcha': function captcha(data) {
                            var fptiData = getPostLoginFpti(data);
                            $logger.info('checkout_fpti', {
                                'from': fptiData.fptiState,
                                'to': 'prepare_captcha'
                            });
                        },
                        'bodyClick': function bodyClick() {
                            $rootScope.$broadcast('clickBody');
                        },
                        'expiredRefreshToken': function expiredRefreshToken(data) {

                            var treatment = data.treatment;

                            $logger.info('EXPIRED_RT_' + treatment);

                            $logger.info('checkout_fpti', {
                                'from': 'LOGIN_UL_RM',
                                'to': 'process_RT_AT_exch',
                                'int_error_code': 'expired_RT_Token',
                                'int_error_desc': treatment,
                                'error_source': 'unifiedloginnodeweb',
                                'error_type': 'soft_decline'
                            });

                            switch (treatment) {

                                case 'showInterstitial':
                                    $scope.showReactivationInterstitial = true;
                                    break;

                                case 'checkboxPreselectedWithNotification':
                                    $scope.errorFn('ONETOUCH_LEAVECHECKED', {}, 'warning');
                                    break;

                                case 'checkboxNotPreselectedWithNotification':
                                    $scope.errorFn('ONETOUCH_REACTIVATE', {}, 'warning');
                                    break;

                                case 'expiredRefreshTokenControl':
                                    break;

                                default:
                                    break;

                            }
                        }
                    };

                    function postMessageHandler(response) {
                        $timeout(function () {
                            $logger.info('ul_postmessaged_received', response);
                            var data = response.data || response.error;
                            var eventId = data && data.event;
                            if (eventId) {
                                $logger.debug('ULLOGIN_' + eventId, response);
                                var handler = ulEventHandlers[eventId];
                                if (handler) {
                                    handler(data);
                                }
                            }
                        });
                    }

                    function loadUnifiedLogin(iframeCopy) {
                        var queryString = $util.queryStringSplice($util.queryString(), {
                            'flow': '1-P',
                            'token': $scope.token
                        }, ['cmd']);
                        var isHermesInsideIframe = $util.isIFrame();
                        if (isHermesInsideIframe) {
                            $logger.info('MERCHANT_IFRAME_INTEGRATION');
                        }
                        var options = {
                            targetElement: document.getElementById('injectedUnifiedLogin'),
                            xhrRequest: isHermesInsideIframe,
                            queryParams: {
                                'stsRedirectUri': ulMeta.stsReturnUrl,
                                'country.x': $scope.locale.country,
                                'locale.x': $scope.locale.getLocaleCode(),
                                'returnUri': ulMeta.ulReturnUri,
                                'state': queryString,
                                'flowId': $scope.token,
                                'correlationId': $CalDataModel.getCalCorrId()
                            },
                            config: {
                                title: 'PayPal - ' + $locale.content.get('common.login')
                            },
                            onPostMessage: postMessageHandler
                        };

                        if ($scope.forcedLogin) {
                            angular.extend(options.queryParams, { 'prompt': 'login' });
                        }

                        if ($scope.logoutCallback) {
                            angular.extend(options.queryParams, { 'showNotYou': true });
                        }

                        if ($stateParams.source !== 'NOT_YOU') {
                            $scope.flowcontext = $scope.checkoutCart.flow_context;
                        } else {
                            $scope.flowcontext = $scope.checkoutCart.flow_context_without_email;
                        }

                        if ($scope.flowcontext) {
                            angular.extend(options.queryParams, { 'flowContextData': $scope.flowcontext });
                        }

                        if ($config.deploy.isLocal()) {
                            options.origin = 'https://' + $meta.stage;
                        }

                        function ulInvoke() {
                            if (PAYPAL && PAYPAL.unifiedLogin) {
                                startTimer('ulInvoke');
                                if (!iframeCopy) {
                                    PAYPAL.unifiedLogin.inject(options);
                                } else {
                                    PAYPAL.unifiedLogin.copyPasteIframe({
                                        targetElement: document.getElementById('injectedUnifiedLogin'),
                                        onPostMessage: postMessageHandler
                                    });
                                }
                            } else {
                                return appLoginHandler(failureReasons.fallback);
                            }
                        }

                        var kmliContentMapping = {
                            xo_hermesnode_kmli_content_control: '0',
                            xo_hermesnode_kmli_content_t1: '1',
                            xo_hermesnode_kmli_content_t2: '2',
                            xo_hermesnode_kmli_content_t3: '3'
                        };

                        if (rememberMe === true) {
                            options.queryParams.rememberMe = true;
                            var country = $scope.checkoutAppData.merchant.merchant_country;
                            return $pxp(ulMeta.kmliContentExpId, { 'ctx.COUNTRY': country }, 'xo_hermesnode_kmli_content_.*').then(function (result) {
                                var contentKey = result && result.treatment_name;

                                if (contentKey && kmliContentMapping[contentKey]) {
                                    options.queryParams.rememberMeContent = kmliContentMapping[contentKey];
                                }

                                ulInvoke();
                            });
                        }

                        return ulInvoke();
                    }

                    var cancelAllLoaded = $rootScope.$on('allLoaded', function () {
                        cancelLocaleChange = $scope.$on('localeChange', function () {
                            userSelectedLanguage = $locale.lang;
                            setLoading('localeChange');
                            loadUnifiedLogin();
                        });
                        cancelAllLoaded();
                    });

                    $scope.$on('$destroy', cancelAllLoaded);

                    loadUnifiedLogin(ulMeta.iframeCopy);
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-login-components/src/unified-login/directive.js
 ** module id = 202
 ** module chunks = 1
 **/